import { gql } from 'graphql-request';
import { graphQLApi } from 'utils/Api';
import {
  QueryListAssignedFlexibleComponentResponse,
  ListAssignedFlexibleComponentInput,
} from '../types';

const getAssignedFlexibleComponentsListQuery = gql`
  query ListAssignedComponents($input: ListAssignedComponentsInput!) {
    payrollListAssignedComponents(input: $input) {
      data {
        assignment_id
        tenant_id
        merchant_id
        component_id
        user_id
        version
        assigned_value
        declared_value
        effective_from
        effective_to
        status
        created_at
        updated_at
        component_name
        component_display_name
        response_precision
        selected_tier_id
        applied_max_amount
      }
      total_count
      code
      success
      message
    }
  }
`;

export const getAssignedFlexibleComponentsList = (input: any) => {
  return graphQLApi<QueryListAssignedFlexibleComponentResponse, ListAssignedFlexibleComponentInput>(
    {
      query: getAssignedFlexibleComponentsListQuery,
      queryVariables: { input },
    },
  );
};
